export class Page<T> {
	public values: T[];

	constructor(values: T[]) {
		this.values = values;
	}
}
